import React from 'react';

import Framework from "@beardeddevops/react.framework";
import {Objects, Collections, Types} from "components";

import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";
import API from "@beardeddevops/react.api";
import {Button} from "reactstrap";
import UniversalModalOverride from "../../../../../components/UniversalModalOverride";

const breadcrumbsStatic = [
	{
		name: 'Dashboard',
		url: '/',
		icon: 'dashboard',
	},
	{
		name: 'Acquisitions',
		url: '/acquisitions',
		icon: 'download',
	},
];

class Acquisition extends Framework.Components.View {

	constructor(props) {
		super(props, 'details');
		this.state.toggleForm = false;
	}

	toggle = (name) => () => {
		this.handleClose();
		this.setState({[name]: !this.state[name]});
	};

	handleOpen = (el) => event => {
		this.setState({
			[el]: event.currentTarget,
		});
	};

	handleClose = () => {
		this.setState({
			anchorGen: null,
		});
	};

	handleAfterP12Save = () => {
		this.refreshPage();
	}

	printPdf = (form, sendEmail) => async () => {
		let model = new API.BuildClass(Types.Transactions_Collections_Forms._name, API.RequestType.CREATE);

		model.object.form = form;
		model.object.send_email = sendEmail;
		model.object.location = this.state.location;
		model.object.location_binary_id = this.state.location_binary_id;
		model.parent = this.props.id;

		try {
			await model.submit(null, API.RequestType.CREATE);
		} catch (e) {
			return;
		}
		this.setState({tab: 'forms'})
		this.refreshPage();
	};

	handleToggleForm = () => {
		this.setState({toggleForm: !this.state.toggleForm})
	};

	generatedForm = () => {
		this.refreshPage();
		this.setState({tab: 'forms'});
	};

	render() {
		let breadcrumbs = breadcrumbsStatic.slice().concat([
			{
				name: this.state.name,
				url: `/acquisitions/${this.props.match.params.id}`,
				icon: 'file-text-o',
			}
		]);

		let hash = this.props.location.hash.replace('#', '');

		if(this.state.tab !== hash && hash !== ""){
			this.setState({tab: hash})
		}

		return (
			<div className="container-fluid">

				<Framework.Components.PageBar breadcrumbs={breadcrumbs} history={this.props.history}>
					{this.props.rootState.hasNYP12Module &&
						<Button onClick={() => this.handleToggleForm()} size="sm" color="primary">
							<i className="fa fa-download"/>&nbsp;&nbsp;Generate New York P12 Form
						</Button>}
					{this.props.rootState.hasMichiganRIModule &&
						<Button onClick={this.printPdf(26, false)} size="sm" color="primary">
							<i className="fa fa-download"/>&nbsp;&nbsp;Generate Michigan RI-060 Form
						</Button>}
					{!this.props.kioskMode &&
						<Button onClick={this.toggle('modalUpload')} size="sm" color="primary">
							<i className="fa fa-check-square-o"/>&nbsp;&nbsp;Upload Files
						</Button>}
				</Framework.Components.PageBar>

				<Tabs value={this.state.tab} onChange={this.handleTabChange} component={'div'}>
					<Tab label="Acquisition" value="details"/>
					<Tab label="Change Log" value="logs"/>
					<Tab label="Uploaded Files" value={'upload'}/>
					{(this.props.rootState.hasImporterModule || this.props.rootState.hasNYP12Module) && <Tab label="forms" value="forms"/>}
				</Tabs>

				<div style={{display: this.state.tab === 'details' ? 'block' : 'none'}}>
					<Objects.Acquisition
						id={this.props.match.params.id}
						history={this.props.history}
						locations={this.props.locations}
						states={this.props.states}
						reloadShell={this.props.reloadShell}
						reloadPage={this.refreshPage}
						reloadSelf={this.state.refresh}
						baseUrl={this.props.baseUrl}
						scannedCode={this.props.scannedCode}
						updateName={this.updateName}
						toggleForm={this.state.toggleForm}
						generatedForm={this.generatedForm}
						userAccess={this.props.rootState.userAccess}
					/>
				</div>
				{this.state.tab === 'logs' &&
					<Collections.LogsAcquisitions
						parent={this.props.match.params.id}
						history={this.props.history}
						locations={this.props.locations}
						states={this.props.states}
						reloadShell={this.props.reloadShell}
						reloadPage={this.refreshPage}
						reloadSelf={this.state.refresh}
					/>}

				{this.state.tab === 'forms' &&
					<Collections.Forms
						parent={this.props.match.params.id}
						forForm={Types.Transactions_Collections_Forms._name}
						url="/transactions/[PARENT]/collections_forms"
						history={this.props.history}
						locations={this.props.locations}
						states={this.props.states}
						reloadShell={this.props.reloadShell}
						reloadPage={this.refreshPage}
						reloadSelf={this.state.refresh}
						afterSave={this.handleAfterP12Save}
					/>}

				{this.state.tab === 'upload' &&
					<Collections.TransactionUploads
						parent={this.props.match.params.id}
						forForm={Types.Transactions_Collections_Forms._name}
						url="/transactions/[PARENT]/collections_forms"
						history={this.props.history}
						locations={this.props.locations}
						states={this.props.states}
						reloadShell={this.props.reloadShell}
						reloadPage={this.refreshPage}
						reloadSelf={this.state.refresh}
					/>}

				<UniversalModalOverride
					locations={this.props.locations}
					states={this.props.states}
					name="Upload Files"
					object={Objects.TransactionUpload}
					history={this.props.history}
					toggle={this.state['modalUpload']}
					reportClose={this.reportClose('modalUpload')}
					afterSave={this.handleAfterSave}
					url="dispositions"
					size="xl"
				/>
			</div>
		)
	}
}

export default Framework.Components.withRootState(Acquisition);